/**
 * Renders the static, pre-generated world map SVG (build-worldmap.mjs).
 * No d3-geo at runtime. No topojson. No React state per frame. Pure image.
 *
 * Compact variant scales down for the /strategic-relationships sidebar.
 */
export default function StaticWorldMap({ compact = false, caption = true }) {
  return (
    <figure className={`gp-static-map ${compact ? "gp-static-map--compact" : ""}`} data-testid="static-world-map">
      <img
        src="/brand/world-map.svg"
        alt="Illustrative world map showing regional connections from the UAE across the Middle East, Africa, Asia, Europe and the Americas."
        className="gp-static-map__img"
        loading="lazy"
        decoding="async"
      />
      {caption && (
        <figcaption className="gp-static-map__caption" data-testid="static-world-map-caption">
          Illustrative resource connections. Not Gold Petroleum shipment routes or live tracking.
        </figcaption>
      )}
    </figure>
  );
}
